export function getHexColorStringFromFeedbackStatus(status, err) {
    if (err) {
        return "#f44336";
    } else if (status === "NEW") {
        return "#5fa052";
    } else if (status === "IN_REVIEW") {
        return "#90caf9";
    } else {
        return "#CB4C4E";
    }
}
